var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.ortefilter)+"\n    "),_vm._l((_vm.filteredList),function(seminar){return _c('w-seminar',{key:seminar.id,attrs:{"seminar":seminar}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }